export const AT_GANTT_VIEW_ACTION_SET =  'GANTT_VIEW_ACTION_SET';
